import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Player from '@vimeo/player';

import { useFullScreen } from '../../contexts/PagesContext';

import styles from '../../../styles/partials/video.module.scss';

const propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    autoFullScreen: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    url: null,
    autoFullScreen: false,
    className: null,
};

const VideoPartial = ({ title, url, autoFullScreen, className }) => {
    const { fullScreen, setFullScreen } = useFullScreen();
    const videoRef = useRef(null);
    useEffect(() => {
        let player = null;
        if (autoFullScreen && videoRef.current && !fullScreen) {
            player = new Player(videoRef.current);
            player.on('play', () => {
                player
                    .requestFullscreen()
                    .then(() => {
                        setFullScreen(true);
                    })
                    .catch(() => {
                        setFullScreen(true);
                    });
            });
        }

        return () => {
            if (player) {
                player.off('play');
            }
        };
    }, [autoFullScreen, fullScreen, setFullScreen, videoRef]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.videoContainer}>
                <iframe
                    className={styles.video}
                    ref={videoRef}
                    title={title || 'Video'}
                    src={url}
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                    allowFullScreen
                />
            </div>
        </div>
    );
};

VideoPartial.propTypes = propTypes;
VideoPartial.defaultProps = defaultProps;

export default VideoPartial;
